import React from "react";
import PropTypes from "prop-types";

/**
 * Thanh bước (step-by-step) cho form tạo Purchase Requisition / Purchase Order —
 * chia field theo từng phần thay vì nhồi hết vào 1 màn hình dài (giống stepper
 * QF-01 của Payment Request). Người dùng điền xong 1 bước mới sang bước kế.
 */
export const StepBadge = ({ n, label, active, done, onClick }) => (
  <div
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    className={`tw-flex tw-items-center tw-gap-2 ${onClick ? "tw-cursor-pointer" : ""}`}
  >
    <span className={`tw-inline-flex tw-h-6 tw-w-6 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-xl tw-text-xs tw-font-semibold ${
      done ? "tw-bg-geist-fg tw-text-white" : active ? "tw-bg-geist-accent tw-text-white" : "tw-bg-geist-100 tw-text-geist-fg-3"
    }`}>
      {done ? <i className="bi bi-check-lg" /> : n}
    </span>
    <span className={`tw-text-sm tw-font-semibold tw-whitespace-nowrap ${active || done ? "tw-text-geist-fg" : "tw-text-geist-fg-3"}`}>{label}</span>
  </div>
);
StepBadge.propTypes = {
  n: PropTypes.number,
  label: PropTypes.node,
  active: PropTypes.bool,
  done: PropTypes.bool,
  onClick: PropTypes.func,
};

const StepperBar = ({ steps, step, onJump }) => (
  <div className="tw-flex tw-items-center tw-gap-3 tw-bg-geist-bg tw-rounded-geist-md tw-border tw-border-solid tw-border-geist-border tw-shadow-geist-card tw-px-4 tw-py-2.5 tw-flex-shrink-0 tw-flex-wrap">
    {steps.map((s, idx) => (
      <React.Fragment key={s.key}>
        {idx > 0 && <span className="tw-flex-1 tw-min-w-[16px] tw-h-px tw-bg-geist-border" />}
        <StepBadge
          n={idx + 1}
          label={s.label}
          active={step === idx}
          done={step > idx}
          onClick={onJump && step > idx ? () => onJump(idx) : undefined}
        />
      </React.Fragment>
    ))}
  </div>
);

StepperBar.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.node,
  })).isRequired,
  step: PropTypes.number.isRequired,
  onJump: PropTypes.func,
};

export default StepperBar;
